import { TrackedEvents, trackEvent } from 'analytics';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton } from 'ui';
import { ImageOutlined, PrecisionManufacturingOutlined } from 'ui/icons';

export const LoadingDetailsDataCard = ({
  isLoading,
  loadingTechnique,
  targetPayload,
  packedOn,
  loadingNotes,
  hasMedia,
}: {
  isLoading?: boolean;
  loadingTechnique?: string | null;
  targetPayload?: number | null;
  packedOn?: string | null;
  loadingNotes?: string | null;
  hasMedia: boolean;
}) => {
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'Loading Details',
    });
    navigate('media?tab=loading');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton icon={<ImageOutlined />} label="Show media" onClick={handleClickMedia} />
          ) : undefined,
          avatar: <PrecisionManufacturingOutlined />,
          title: 'Loading details',
        },
      }}
    >
      {loadingTechnique ? <DataCard.Item title="Loading technique">{loadingTechnique}</DataCard.Item> : null}
      {Boolean(targetPayload) && <DataCard.Item title="Target payload">{targetPayload} (MT)</DataCard.Item>}
      {packedOn ? <DataCard.Item title="Packed On">{packedOn}</DataCard.Item> : null}
      {loadingNotes ? (
        <DataCard.Item title="Loading notes" colSpan={12}>
          {loadingNotes}
        </DataCard.Item>
      ) : null}
    </DataCard>
  );
};
